import { Menu, X } from 'lucide-react';
import { useState } from 'react';

const navItems = [
  { label: 'Platform', href: '/platform' },
  { label: 'Websites', href: '/websites' },
  { label: 'Channels', href: '/channels' },
  { label: 'Compliance', href: '/compliance' },
  { label: 'Workflow', href: '/workflow' },
  { label: 'Proof', href: '/proof' },
];

export function Header() {
  const [open, setOpen] = useState(false);
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

  return (
    <header className="site-header">
      <a className="brand-link" href="/" aria-label="Beyond4 home">
        <img src="/logos/beyond-logo-blue.svg" alt="Beyond4" />
      </a>
      <button className="nav-toggle" type="button" aria-label="Toggle navigation" onClick={() => setOpen((value) => !value)}>
        {open ? <X size={22} /> : <Menu size={22} />}
      </button>
      <nav className={open ? 'site-nav site-nav-open' : 'site-nav'} aria-label="Primary navigation">
        {navItems.map((item) => (
          <a key={item.href} href={item.href} aria-current={currentPath === item.href || currentPath.startsWith(`${item.href}/`) ? 'page' : undefined} onClick={() => setOpen(false)}>
            {item.label}
          </a>
        ))}
        <a className="nav-cta" href="/contact" onClick={() => setOpen(false)}>
          Sign up
        </a>
      </nav>
    </header>
  );
}
